/**
 * The explicit marker.
 *
 * A filled square with an E, sat immediately left of a title - the convention
 * every music service shares, which is the whole reason to draw it this way
 * rather than better. Somebody who has seen it once elsewhere should not have
 * to work out what it means here.
 *
 * ## It is a label, not a warning
 *
 * Grey rather than red. The flag says the artist declared explicit content; it
 * does not say anything is wrong, and colouring it like an error would make a
 * neutral fact look like a judgement on the work.
 *
 * ## Named for screen readers, since the letter is not the word
 *
 * "E" read aloud is a letter. The `title` and `aria-label` carry the meaning,
 * and the glyph is hidden from the accessibility tree so it is announced once.
 */
export function Explicit({ className = '' }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Explicit"
      title="Explicit"
      data-explicit
      className={`inline-flex h-[15px] w-[15px] shrink-0 items-center justify-center rounded-[3px] bg-[#3a3a52] text-[10px] font-bold leading-none text-[#c8c8dc] ${className}`}
    >
      <span aria-hidden>E</span>
    </span>
  );
}
